import React from "react";
import Certifications from "./Certifications";
import Superbadges from "./Superbadges";

function Achievements() {
  return (
    <div className="achievementsPage">
      <Certifications />
      <Superbadges />
    </div>
  );
}

export default Achievements;